import {
  base_contentActive,
  gradient_brandGradientEnd,
  gradient_brandGradientStart,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { fontFormLabel } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  &.EnableVirtualCardCTA {
    position: relative;
    background: ${base_contentActive};
    border-radius: 12px;
    padding: ${spacing(5)};
    margin-bottom: ${spacing(4)};

    /* Gradient border */
    &::before {
      content: '';
      position: absolute;
      inset: 0;
      padding: 2px;
      border-radius: 12px;
      background: linear-gradient(
        180deg,
        ${gradient_brandGradientStart} 0%,
        ${gradient_brandGradientEnd} 100%
      );
      -webkit-mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
      mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
      -webkit-mask-composite: xor;
      mask-composite: exclude;
      pointer-events: none;
    }

    .create-text {
      ${fontFormLabel}
    }
    .cta-button {
      max-width: 130px;
      padding: ${spacing(2)} ${spacing(4)};
    }
  }
`
